<template>
    <div>
        <b-card>
            <b-card-body>
                <b-media>
                    <template #aside>
                        <img class="image-size" src="@/assets/img/iconvehincle.png" alt="MUIC">
                    </template>
                    <h3 class="mt-3 mb-3 font-Rubik-ven-in">IC Vehicle Booking System</h3>
                </b-media>
                <div class="row mb-3">
                    <div class="col-sm-12 col-md-12 col-lg-4 col-lg-4 mb-3">
                        <h5 class="mt-3 font-weight-bold"><i class="fa fa-file-text mr-2" aria-hidden="true"/>Vehicle Booking Form</h5>
                        <p class="f-12 mt-2 mb-0 text-danger">
                            In case of booking a car after working hours, the admin will arrange the car within working hours of the following day (9:00 - 16:00).
                        </p>
                        <p class="f-12 mt-2 mb-3">
                            For urgent matter, please contact 02-700-5000 Ext.1101 or call 064-9251438
                        </p>
                        <b-form class="mt-4 a-car">
                            <label class="text-dark font-weight-bold">Email :<span class="ml-2 text-danger">*</span></label>
                            <b-form-group
                                description="If you want to reserve a car on behalf of someone elfe, you can use an email of ..."
                                :state="isMail"
                                invalid-feedback="Bad email format"
                            >
                                <b-form-input
                                    class="font-Rubik-ven-in"
                                    type="email"
                                    placeholder="Enter email"
                                    :state="isMail"
                                    v-model="form.email"
                                    autocomplete="off" trim
                                ></b-form-input>
                            </b-form-group>
                            <label class="text-dark font-weight-bold">Reason:<span class="ml-2 text-danger">*</span></label>
                            <b-form-group
                                id="input-group-1"
                                label=""
                                label-for="input-1"
                                description=""
                                class="mt-0 mb-3"
                            >
                                <b-form-select 
                                    class="font-Rubik-ven-in"
                                    :options="optionPass"
                                    v-model="form.reason"
                                ></b-form-select >
                            </b-form-group>
                            <label class="text-dark font-weight-bold">Destination should be more specific. It should include, for example, "address", "Amphur", "Province".<span class="ml-2 text-danger">*</span></label>
                            <b-form-group
                                id="input-group-1"
                                label=""
                                label-for="input-1"
                                description=""
                                class="mt-0 mb-3"
                            >
                                <b-form-input
                                    type="text"
                                    placeholder="Enter..."
                                    autocomplete="off" trim
                                    class="font-thai"
                                    v-model="form.Destination"
                                ></b-form-input>
                            </b-form-group>
                            <label class="text-dark font-weight-bold">Number of passengers:<span class="ml-2 text-danger">*</span></label>
                            <b-form-group description=" Note that it can have negative integer and zero!">
                                <b-form-input
                                    class="font-Rubik-ven-in"
                                    type="number"
                                    v-model="form.passenger"
                                    autocomplete="off" trim
                                ></b-form-input>
                            </b-form-group>
                            <label class="text-dark font-weight-bold">Remark: (if any)</label>
                            <b-form-textarea
                                placeholder="Enter Detail..."
                                rows="3"
                                max-rows="6"
                                class="font-thai mb-3"
                                autocomplete="off" trim
                                v-model="form.Remark"
                            ></b-form-textarea>
                            <label class="text-dark font-weight-bold">Time<span class="ml-2 text-danger">*</span></label>
                            <br>
                            <!-- {{ moment(form.timeStart, "HH:mm:ss").format("HH:mm:ss") }} - {{ moment(form.timeEnd, "HH:mm:ss").format("HH:mm:ss") }} -->
                            <!-- {{ isTimeBooking }} -->
                            <br>
                            <label class="mt-1 font-Rubik-ven text-success mr-sm-2">Use start</label>
                            <b-form-input v-model="form.dayStart" class="font-Rubik-ven-in mb-2 mr-sm-2" type="date"></b-form-input>
                            <b-form-input v-model="form.timeStart" locale="en" class="font-Rubik-ven-in mr-sm-2 mb-2" type="time"></b-form-input>
                            <!-- <vue-timepicker :format="yourFormat" v-model="form.timeStart"></vue-timepicker> -->
                            <br>
                            <label class="font-Rubik-ven text-danger mr-sm-2">Use end</label>
                            <br>
                            <b-form-input v-model="form.dayEnd" class="font-Rubik-ven-in mb-2 mr-sm-2" type="date"></b-form-input>
                            <!-- <vue-timepicker :format="yourFormat" v-model="form.timeEnd"></vue-timepicker> -->
                            <b-form-input v-model="form.timeEnd" class="font-Rubik-ven-in mr-sm-2 mb-3" type="time"></b-form-input>
                            <!-- btn submit -->
                            <b-button class="font-Rubik-child" v-if="loadBtnSubmit" variant="warning" disabled>
                                <b-spinner small class="mr-1"></b-spinner>sending load request booking ...
                            </b-button>
                            <b-button v-else block :disabled="!isFormValid || !isTimeBooking" @click="submitVehicle" class="chk-btn-f mt-2 mb-3" size="sm" variant="success"><i class="fa fa-plus mr-1" aria-hidden="true"/>Submit</b-button>
                            <!-- log error -->
                            <div v-if="errorSubmit !== null">
                                <p class="mt-1 mb-1 font-Rubik-ven text-danger">*** {{ errorSubmit }} ***</p>
                            </div>
                        </b-form>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-8 col-lg-8">
                        <h5 class="mt-3 mb-3"><i class="fa fa-clock-o mr-2" aria-hidden="true"/>Recent Vehicle</h5>
                        <b-table 
                            responsive="sm"
                            class="mt-1 font-Rubik-ven"
                            small
                            bordered show-empty
                            head-variant="dark"
                            :busy="LoadRecent"
                            :items="itemsVehicle"
                            :fields="fieldsVehicle"
                        >
                            <template v-slot:table-busy>
                                <div class="thai-font text-center my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    loading data request...
                                </div>
                            </template>
                            <template v-slot:cell(a)="row">
                                <p class="f-time mt-1 mb-1 font-Rubik-ven-in text-muted">Reason :</p>
                                <p class="mt-1 mb-1 font-Rubik-ven-in">{{ row.item.eng_detail }}</p>
                                <p class="mt-1 mb-1 font-Rubik-ven-in"><span class="f-time text-muted mr-2">Destination :</span><span class="font-thai">{{ row.item.destination }}</span></p>
                                <p class="mt-1 mb-1 font-Rubik-ven-in"><span class="f-time text-muted mr-2">Passenger :</span>{{ row.item.passenger }} people</p>
                                <div v-if="row.item.remark !== null && row.item.remark !== ''">
                                    <p class="f-time mt-1 mb-1 font-Rubik-ven-in text-muted">
                                        Remark :
                                    </p>
                                    <div style="max-width: 300px" class="d-inline-block ml-3 mb-3">
                                        <span class="readText font-thai">{{ row.item.remark }}</span>
                                        <!-- style="max-width: 250px" class="d-inline-block text-truncate font-thai" -->
                                    </div>
                                </div>
                                <p class="mt-2 mb-1 font-Rubik-ven-in f-time text-muted">Departure:</p>
                                <p class="mt-2 mb-1 font-Rubik-ven-in"><span class="ml-2 mr-2 text-success">{{ moment(row.item.use_start).locale('th').format('L') }}</span>Time :<span class="ml-2 text-success">{{ moment(row.item.use_start).locale('th').format('LT') }}</span></p>
                                <p class="mt-1 mb-1 font-Rubik-ven-in"><span class="ml-2 mr-2 text-danger">{{ moment(row.item.use_end).locale('th').format('L') }}</span>Time :<span class="ml-2 text-danger">{{ moment(row.item.use_end).locale('th').format('LT') }}</span></p>
                            </template>
                            <template v-slot:cell(b)="row">
                                <div v-if="row.item.status === 'approve'">
                                    <h5 class="mt-0 mb-2 thai-font">Driver</h5>
                                    <b-media>
                                        <template #aside>
                                            <img class="img-responsive image-size-32" :src="row.item.driver_detail.driver_detail.img" @error="imageUrlAlt" alt="profile" />
                                            <!-- <b-img :src="row.item.driver_detail.driver_detail.img" width="64" alt="placeholder"></b-img> -->
                                        </template>
                                        <p class="f-time mt-1 mb-1 font-Rubik-ven-in text-dark">{{ row.item.driver_detail.driver_detail.name }} {{ row.item.driver_detail.driver_detail.surname }}</p>
                                        <p class="f-time mt-1 mb-1 font-Rubik-ven-in">{{ row.item.driver_detail.driver_detail.email }}</p>
                                        <p class="f-time mt-1 mb-1 font-Rubik-ven-in text-muted">Moblie phone : <strong>{{ row.item.driver_detail.tel }}</strong></p>
                                        <p class="f-time mt-1 mb-1 font-Rubik-ven-in text-muted">Office phone : <strong>{{ row.item.driver_detail.driver_detail.telephone }}</strong></p>
                                    </b-media>
                                    <h5 class="mt-2 mb-0 thai-font">Car</h5>
                                    <b-media class="mt-2">
                                        <template #aside>
                                            <b-img :src="row.item.car_detail.img" class="image-size-32" alt="placeholder"></b-img>
                                        </template>
                                        <h5 class="mt-0 mb-0 font-Rubik-ven-in">{{ row.item.car_detail.code }}</h5>
                                        <p class="mb-0 f-small-car font-thai">{{ row.item.car_detail.detail }}</p>
                                    </b-media>
                                </div>
                                <div v-if="row.item.status === 'wait'">
                                    <p class="f-time mt-4 mb-1 font-Rubik-ven-in text-muted">Waiting for driver recruitment</p>
                                </div>
                                <div v-if="row.item.status === 'cancel'">
                                    <p class="f-time mt-4 mb-1 font-Rubik-ven-in text-muted">
                                        {{ row.item.reason_of_cancel }}
                                    </p>
                                </div>
                            </template>
                            <template v-slot:cell(status)="row">
                                <i class="fa" :class="{ 'text-warning fa-hourglass-start' : row.item.status === 'wait' , 'text-success fa-check-circle' : row.item.status === 'approve' , 'text-danger fa-times' : row.item.status === 'cancel' }" aria-hidden="true" />
                                <strong class="font-Rubik-ven-in">{{ row.item.status }}</strong>
                            </template>
                            <template v-slot:cell(action)="row">
                                <b-button
                                    variant="danger"
                                    size="sm"
                                    v-if="row.item.status === 'wait'" 
                                    class="text-danger zoom-btn" 
                                    @click="delBookCarRequest(row.item.id)"
                                >
                                    <i class="text-light fa fa-trash" aria-hidden="true" />
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    import defaultImg from '@/assets/img/avatar.png'
    const validateEmail = email => {
        //eslint-disable-next-line
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };
    const formReservedVehicle = {
        email: '',
        reason:'',
        passenger:'',
        Destination: '',
        Remark: '',
        dayStart: '',
        timeStart: '',
        dayEnd: '',
        timeEnd: '',
    }
    
    export default {
        data(){
            return{
                loadBtnSubmit:false,
                errorSubmit: null,
                LoadRecent:false,
                itemsVehicle: [],
                errorList: null,
                form : Object.assign({}, formReservedVehicle),
                optionPass:[],
                yourFormat: 'hh:mm a',
                fieldsVehicle: [ 
                    {
                        key: 'a',
                        label: 'Book Detail', 
                        class: '',
                        thStyle: 
                        { 
                            fontFamily: 'Rubik',
                            fontSize: '14px',
                            width:'45%',
                        }
                    },
                    {   
                        key: 'b',
                        label: '', 
                        class: '',
                        thStyle: 
                        { 
                            fontFamily: 'Rubik',
                            fontSize: '14px',
                            width:'35%',
                        },
                    },
                    { 
                        key: 'status',
                        label: 'Status', 
                        class: 'text-center',
                        thStyle: 
                        { 
                            fontFamily: 'Rubik',
                            fontSize: '14px',
                            width:'10%',
                        }
                    },
                    {
                        key: 'action',
                        label: '',
                        class: 'text-center',
                        thStyle: 
                        { 
                            fontFamily: 'Rubik',
                            fontSize: '14px',
                            width:'10%',
                        }
                    },
                ],
            }
        },
        computed: {
            isMail() {
                if (this.form.email === "") return null;
                return validateEmail(this.form.email);
            },
            isFormValid(){
                if (this.form.email !== '' && this.form.passenger !== '' && this.form.reason !== '' && this.form.Destination !== '' && this.form.dayStart !== '' && this.form.timeStart !== '' && this.form.dayEnd !== '' && this.form.timeEnd !== '') {
                    return true;
                } else {
                    return false;
                }
            },
            isTimeBooking(){
                if(this.form.timeStart !== '' && this.form.timeEnd !== ''){
                    var start  = `${this.moment(this.form.dayStart).format("DD/MM/YYYY")} ${this.moment(this.form.timeStart, "HH:mm:ss").format("HH:mm:ss")}`
                    var end = `${this.moment(this.form.dayEnd).format("DD/MM/YYYY")} ${this.moment(this.form.timeEnd, "HH:mm:ss").format("HH:mm:ss")}`
                    var ms = this.moment(start,"DD/MM/YYYY HH:mm:ss").diff(this.moment(end,"DD/MM/YYYY HH:mm:ss"));
                    // console.log(ms)
                    // var d = this.moment.duration(ms);
                    // console.log(d._milliseconds)
                    if(ms > 0){
                        return false
                    }else{
                        return true
                    }
                }else{
                    return false
                }
            }
        },
        mounted(){
            this.getResson()
            this.getVehicle()
            this.form.email = this.$keycloak.tokenParsed.email
        },
        methods:{
            async getResson(){
                this.optionPass = []
                try {
                    const res = await this.$http.get(`/vehicle/reason/`)
                    if(res.status === 200){
                        this.optionPass = res.data.map(item => {
                            return {
                                'value': item.id,
                                'text': `${item.eng_detail}`,
                            }
                        })
                        this.optionPass.push({value: '', text: 'Please select' , disabled: true})
                    }else{
                        throw { res }
                    }
                } catch (error) {}
            },
            async getVehicle(){
                this.LoadRecent = true
                this.errorList = null
                this.itemsVehicle = []
                try {
                    const res = await this.$http.get(`/vehicle/booking/`)
                    if(res.status === 200){
                        this.itemsVehicle = res.data.map(item => {
                            return {
                                'no': item.id,
                                'id': item.id,
                                'email': item.email,
                                'destination': item.destination,
                                'reason': item.reason,
                                'reason_of_cancel': item.reason_of_cancel,
                                'remark': item.remark,
                                'eng_detail': item.reason_detail.eng_detail,
                                'thai_detail': item.reason_detail.thai_detail,
                                'passenger': item.passenger,
                                'use_start': item.use_start,
                                'use_end': item.use_end,
                                'status': item.status,
                                'updated_at': item.updated_at,
                                'created_at': item.created_at,
                                'car': item.car,
                                'car_detail': item.car_detail,
                                'driver': item.driver,
                                'driver_detail': item.driver_detail,
                            }
                        })
                        this.LoadRecent = false
                        this.itemsVehicle.sort((a, b) =>{ return b.id - a.id; });
                    }else{
                        throw { res }
                    }
                } catch (error) {
                    this.LoadRecent = false
                    this.errorList = error
                }
            },
            async submitVehicle(){
                this.loadBtnSubmit = true
                this.errorSubmit = null
                const sendData = new FormData()
                sendData.append('email', this.form.email)
                sendData.append('destination', this.form.Destination)
                sendData.append('reason', this.form.reason)
                sendData.append('passenger', this.form.passenger)
                sendData.append('use_start', this.moment(this.form.dayStart).format('YYYY-MM-DD')+'T'+this.form.timeStart+'+07:00')
                sendData.append('use_end', this.moment(this.form.dayEnd).format('YYYY-MM-DD')+'T'+this.form.timeEnd+'+07:00')
                if(this.form.Remark !== '' || this.form.Remark !== null){
                    sendData.append('remark', this.form.Remark)
                }else{ sendData.append('remark', '-') }
                try {
                    const response = await this.$http.post('/vehicle/booking/',
                        sendData,
                        {
                            headers: { 'Content-Type': 'multipart/form-data' }
                        }
                    )
                    if(response.status === 201){ 
                        this.form = Object.assign({}, formReservedVehicle) 
                        this.getVehicle()
                        this.loadBtnSubmit = false
                    }else{
                        throw { response }
                    }
                } catch (error) {
                    this.loadBtnSubmit = false
                    this.errorSubmit = error
                }
            },
            confirmDelete(){},
            async delBookCarRequest(id){
                try {
                    const res = await this.$http.delete(`/vehicle/booking/${id}/remove/`)
                    if(res.status === 200){
                        this.getVehicle()
                    }else{
                        throw { res }
                    }
                } catch (error) {}
            },
            imageUrlAlt(event) {
                event.target.src = defaultImg
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@500&display=swap');
    .a-car{
        color: #1b1e21;
        background-color: #f1f2f3;
        border-radius: 5px;
        padding: 20px;
    }
    .image-size{
        width:64px;
        height:64px;
    }
    .image-size-32{
        width:50px;
        height:50px;
    }
    .font-Rubik-ven{
        font-family: 'Rubik', sans-serif;
        font-weight: 500;
    }
    .font-Rubik-ven-in{
        font-family: 'Rubik', sans-serif;
        font-weight: 300;
    }
    .f-small-car{ font-size: 0.8rem; }
    .f-time{ font-size: 0.85rem; }
    .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .readText{ max-width: 250px; white-space: pre-line; }
    .f-12{
        font-size: 14px;
    }
    .w-5{ width: 5%; }
    .w-20{ width: 20%; }
    .w-35{ width: 35%; }
    .w-40{ width: 40%; }
    .w-50{ width: 50%; }
    .w-55{ width: 55%; }
    .w-75{ width: 75%; }
    .w-80{ width: 80%; }
    .w-95{ width: 95%; }
</style>